import React, { PureComponent, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getRequests, changePage, changePerPage, onChangeSort, resetRequests } from './actions';
import { getRequestsList, getSuccessStatus, getLoadingStatus } from './selector';

import CustomTable from '../../../components/shared/table/CustomTable';
import RequestsHeader from './RequestsHeaderBuscarCobranca';
import RequestLine from './RequestLineBuscarCobranca';
import PaginationFooter from '../../../components/shared/table/PaginationFooter';

class RequestsTable extends PureComponent {
  state = {
    current: 'id',
    sort: 'ASC',
    idsChecked: []
  }

  componentDidMount() {
    const {params: {id}} = this.props.match
    this.props.getRequests(id);
  }

  componentWillUnmount() {
    this.props.resetRequests();
  }

  onChangePage = (page) => {
    const {params: {id}} = this.props.match
    this.props.changePage(page);
    this.props.getRequests(id);
    this.props.onChangePage(page);
  }

  onChangeResultsperPage = (perPage) => {
    const {params: {id}} = this.props.match
    this.props.changePerPage(perPage);
    localStorage.setItem("resultsPerPageRequests", perPage);
    this.props.getRequests(id);
  }

  changeCurrentSort = (name) => {
    const { current, sort } = this.state;
    let newSort = '';
    if (current === name) {
      newSort = sort === "ASC"? 'DESC' : 'ASC';
    } else {
      newSort = 'ASC';
    }
    this.setState({ current: name, sort: newSort }, () => {
      const {params: {id}} = this.props.match
      const apiSort = (newSort === "DESC")? `-${name}` : name;
      this.props.onChangeSort(apiSort);
      this.props.getRequests(id);
    });
  }

  renderHeader = () => (
    <RequestsHeader 
      sortHandler={this.changeCurrentSort} 
      current={this.state.current} 
      sort={this.state.sort} />
    )

  renderLine = (line, index) => {
    const onGoToResume = () => this.props.history.push({
      pathname: '/intranet/operacional/solicitacao/resumo',
      state: { request: line.id, cliente_id: line.cliente_id }
    });

    return (
      <RequestLine
        key={line.id.toString()}
        {...line}
        index={index}
        length={this.props.lines.length}
        handleChangeCheck={this.props.handleChangeCheck}
        // onGoToResume={onGoToResume}
      />
    );
  }

  render() {
    return (
      <Fragment>
        <CustomTable
          loading={this.props.requesting}
          lines={this.props.listData}
          renderHeader={this.renderHeader}
          renderLine={this.renderLine}
        />
        
         <PaginationFooter 
          pagination={this.props.pagination}
          changePage={this.onChangePage}
          changeMaxResults={this.onChangeResultsperPage}
          callToAction={this.props.callToAction}
        />
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ getRequests, changePage, changePerPage, onChangeSort, resetRequests }, dispatch);

const mapStateToProps = (state) => ({
  lines: getRequestsList(state),
  // pagination: state.requestsTable.pagination,
  login: state.login,
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RequestsTable));
